export const build = {"tag":"v1.0.5","hash":"670f6f88","time":"261015.0928"}